// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"Organizers_header-wrapper__3YXc7","organizer-header":"Organizers_organizer-header__2u8-H","ieee":"Organizers_ieee__1S09M","signal":"Organizers_signal__3sa0d"};